import { render, staticRenderFns } from "./TakeOverModalNew.vue?vue&type=template&id=02c31d50&scoped=true&"
import script from "./TakeOverModalNew.vue?vue&type=script&lang=js&"
export * from "./TakeOverModalNew.vue?vue&type=script&lang=js&"
import style0 from "./TakeOverModalNew.vue?vue&type=style&index=0&id=02c31d50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c31d50",
  null
  
)

export default component.exports